import { Menu } from '@core/models';

export function findDefaultMenuForChannel(menus: Menu[], channelName: string): Menu | null {
	return menus.find(menu => menu.porDefecto && menu.canales.some(channel => channel.nombre === channelName)) ?? null;
}
